
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claim-book",
      function () {
        return require("private-next-pages/claim-book/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claim-book"])
      });
    }
  